import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { CContainer } from '@coreui/react-pro';

// routes config
import { systemAdminRoutes } from '../../routes';
import CenterSpinner from '../../components/General/Loadings/CenterSpinner';

const SystemAdminContent = () => {
     const element = useRoutes(systemAdminRoutes);

     return (
          <main className="c-main">
               <CContainer fluid>
                    <Suspense fallback={<CenterSpinner />}>{element}</Suspense>
               </CContainer>
          </main>
     );
};

export default SystemAdminContent;
